import { render, staticRenderFns } from "./PageNav.vue?vue&type=template&id=35376d03&scoped=true&"
import script from "./PageNav.vue?vue&type=script&lang=js&"
export * from "./PageNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35376d03",
  null
  
)

export default component.exports